export const frontWebRoutes = [
    {
        path: '/courseBrief/:id',
        name: 'courseBriefDetail',
        component: () => import('@/views/frontWeb/course/index'),
    },
    {
        // 问答页面
        path: '/qa',
        name: 'qaMain',
        component: () => import('@/views/frontWeb/qa/list/index')
    },
    {
        // 问答页面
        path: '/qaDetail',
        name: 'qaDetail',
        component: () => import('@/views/frontWeb/qa/detail/detail.vue')
    },
]
